export class MaxDecimalsValueConverter {
  public toView(value: unknown, maxDecimals = 2) {
    if (value === null || value === undefined || value === '') {
      return value;
    }
    const parsed = parseFloat(value as string);
    if (isNaN(parsed)) return '';

    const factor = Math.pow(10, maxDecimals);
    const rounded = Math.round(parsed * factor) / factor;
    return rounded
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
